import { formFieldsPlaygroundFields as fields } from "./formFieldsPlayground.schema";
import { StateRow, TIP } from "./FormFieldsPlaygroundStateRow";

const EMAILS_PLACEHOLDER = "Emails, comma separated";

/** The email and phone kit fields in every state. */
export const FormFieldsPlaygroundContactRows = () => (
    <>
        <StateRow
            title="fields.Emails"
            cells={{
                normal: (
                    <fields.Emails
                        name="emails.normal"
                        label="Invite"
                        placeholder={EMAILS_PLACEHOLDER}
                    />
                ),
                optional: (
                    <fields.Emails
                        name="emails.optional"
                        label="CC"
                        optional
                        placeholder={EMAILS_PLACEHOLDER}
                    />
                ),
                tip: (
                    <fields.Emails
                        name="emails.tip"
                        label="Invite"
                        description="Invalid addresses are rejected"
                        placeholder={EMAILS_PLACEHOLDER}
                    />
                ),
                error: <fields.Emails name="emails.error" label="Invite" />,
                disabled: (
                    <fields.Emails
                        name="emails.disabled"
                        label="Invite"
                        disabled
                    />
                ),
            }}
        />
        <StateRow
            title="fields.Phone"
            cells={{
                normal: <fields.Phone name="phone.normal" label="Phone" />,
                optional: (
                    <fields.Phone
                        name="phone.optional"
                        label="Mobile"
                        optional
                    />
                ),
                tip: (
                    <fields.Phone
                        name="phone.tip"
                        label="Phone"
                        description={TIP}
                    />
                ),
                error: <fields.Phone name="phone.error" label="Phone" />,
                disabled: (
                    <fields.Phone
                        name="phone.disabled"
                        label="Phone"
                        disabled
                    />
                ),
            }}
        />
    </>
);
